(() => {
  const preloader = document.getElementById('preload');
  if (preloader) {
    const startedAt = performance.now();
    let dismissed = false;
    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      preloader.classList.add('tp-off');
      preloader.setAttribute('aria-hidden', 'true');
      setTimeout(() => preloader.remove(), 400);
    };
    const ready = () => setTimeout(dismiss, Math.max(0, 500 - (performance.now() - startedAt)));
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) dismiss();
    else if (document.readyState === 'complete') ready();
    else window.addEventListener('load', ready, {once: true});
    setTimeout(dismiss, 1400);
    window.addEventListener('pageshow', event => { if (event.persisted) dismiss(); });
  }
  const updatePrice = (container, selected) => {
    const price = container?.querySelector('[data-launch-sale]');
    if (!price) { if (container) container.textContent = selected.dataset.price; return; }
    const onSale = price.dataset.launchSale === 'true';
    price.querySelector('[data-sale-current] [data-sale-amount]').textContent = onSale ? selected.dataset.salePrice : selected.dataset.price;
    const regular = price.querySelector('[data-sale-regular]');
    const saving = price.querySelector('[data-sale-saving]');
    if (regular) regular.querySelector('[data-sale-amount]').textContent = selected.dataset.regularPrice;
    if (saving) saving.textContent = selected.dataset.saleSaving;
  };
  let bagController;
  const initializeBag = () => {
    const dialog = document.getElementById('tpBagDialog');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    const content = dialog.querySelector('[data-bag-content]');
    const notice = dialog.querySelector('[data-bag-notice]');
    const errorBox = dialog.querySelector('[data-bag-error]');
    let busy = false;
    let returnFocus;
    const setBusy = value => {
      busy = value;
      content.setAttribute('aria-busy', String(value));
      content.querySelectorAll('input,button:not([data-bag-close])').forEach(el => { el.disabled = value; });
    };
    const setNotice = message => { notice.textContent = message; notice.hidden = !message; };
    const showError = message => { errorBox.querySelector('[data-bag-error-text]').textContent = message; errorBox.hidden = false; };
    const open = (message, opener) => {
      errorBox.hidden = true;
      setNotice(message);
      if (!dialog.open) {
        returnFocus = opener || document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('tp-bag-open');
      }
    };
    const render = html => {
      if (typeof html !== 'string') return false;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bag-content]');
      if (!next) return false;
      content.innerHTML = next.innerHTML;
      const count = Number(content.querySelector('[data-bag-count]')?.dataset.bagCount || 0);
      document.querySelectorAll('#cartCount').forEach(badge => { badge.textContent = count; badge.hidden = count === 0; });
      setBusy(busy);
      return true;
    };
    const sectionUrl = () => {
      const url = new URL(dialog.dataset.cartUrl, location.origin);
      url.hash = '';
      url.searchParams.set('sections', dialog.dataset.sectionId);
      return url;
    };
    const refresh = async () => {
      const response = await fetch(sectionUrl(), {cache: 'no-store'});
      if (!response.ok) throw new Error(dialog.dataset.error);
      const sections = await response.json();
      if (!render(sections[dialog.dataset.sectionId])) throw new Error(dialog.dataset.error);
    };
    const change = async (key, quantity, focusLabel) => {
      if (busy || !Number.isInteger(quantity) || quantity < 0) return;
      setBusy(true);
      errorBox.hidden = true;
      setNotice(dialog.dataset.loading);
      try {
        const response = await fetch(dialog.dataset.changeUrl, {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: key, quantity, sections: [dialog.dataset.sectionId], sections_url: location.pathname + location.search})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : dialog.dataset.error);
        if (!render(data.sections?.[dialog.dataset.sectionId])) await refresh();
        setNotice('');
      } catch (error) {
        try { await refresh(); } catch (_) { content.innerHTML = ''; }
        setNotice('');
        showError(error.message === 'Failed to fetch' ? dialog.dataset.error : error.message || dialog.dataset.error);
      } finally {
        setBusy(false);
        const focus = Array.from(content.querySelectorAll('[aria-label]')).find(el => el.getAttribute('aria-label') === focusLabel);
        (focus || dialog.querySelector('[data-bag-close]')).focus({preventScroll: true});
      }
    };
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-bag-close]')) dialog.close();
      const button = event.target.closest('[data-bag-change]');
      if (button) change(button.dataset.key, Number(button.dataset.quantity), button.getAttribute('aria-label'));
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    content.addEventListener('change', event => {
      const input = event.target.closest('[data-bag-quantity]');
      if (!input) return;
      if (!input.value || !input.checkValidity()) { input.reportValidity(); return; }
      change(input.dataset.key, Number(input.value), input.getAttribute('aria-label'));
    });
    content.addEventListener('submit', event => {
      if (busy || event.submitter?.name !== 'checkout') event.preventDefault();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('tp-bag-open');
      if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
    });
    bagController = {
      sectionId: dialog.dataset.sectionId,
      reserve() { if (busy) return false; setBusy(true); return true; },
      release() { setBusy(false); },
      async show(opener) {
        if (busy) return;
        open(dialog.dataset.loading, opener);
        setBusy(true);
        try { await refresh(); setNotice(''); }
        catch (_) { content.innerHTML = ''; setNotice(''); showError(dialog.dataset.error); }
        finally { setBusy(false); }
      },
      async confirm(sections, opener) {
        open(dialog.dataset.added, opener);
        try { if (!render(sections?.[dialog.dataset.sectionId])) await refresh(); }
        catch (_) { content.innerHTML = ''; showError(dialog.dataset.addedFallback); }
      }
    };
  };
  document.addEventListener('click', event => {
    const bagLink = event.target.closest('#btnCart');
    if (!bagLink || !bagController || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || document.querySelector('.tp-cart')) return;
    event.preventDefault();
    bagController.show(bagLink);
  });

  const initializeWelcome = () => {
    const dialog = document.getElementById('tpLaunchWelcome');
    if (!dialog || dialog.dataset.bound || typeof dialog.showModal !== 'function') return;
    dialog.dataset.bound = 'true';
    const inEditor = dialog.dataset.editor === 'true';
    const sessionKey = 'tp-launch-welcome:' + dialog.dataset.campaign + (inEditor ? ':editor' : '');
    let shown = false;
    let returnFocus;
    let canAutoShow = true;
    try { if (sessionStorage.getItem(sessionKey)) canAutoShow = false; }
    catch (_) { canAutoShow = false; }
    const remember = () => {
      shown = true;
      try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
    };
    const show = manual => {
      if (!dialog.isConnected || dialog.open || document.hidden) return;
      if (!manual && (!canAutoShow || shown)) return;
      const active = document.activeElement;
      if (document.querySelector('dialog[open], #nav.open') || (!manual && active?.matches('input, textarea, select, [contenteditable="true"]'))) {
        if (!manual) remember();
        return;
      }
      returnFocus = active;
      dialog.showModal();
      document.documentElement.classList.add('tp-welcome-open');
      remember();
    };
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-welcome-close], [data-welcome-shop]')) dialog.close();
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('tp-welcome-open');
      if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-welcome-preview]')) show(true);
    });
    if (canAutoShow) {
      setTimeout(() => show(false), 2200);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && !shown) setTimeout(() => show(false), 2200); });
    }
  };

  const initialize = () => {
    initializeWelcome();
    initializeBag();
    const menuButton = document.getElementById('burger');
    const menu = document.getElementById('nav');
    if (menuButton && menu && !menuButton.dataset.bound) {
      menuButton.dataset.bound = 'true';
      const closeMenu = () => { menu.classList.remove('open'); menuButton.setAttribute('aria-expanded', 'false'); };
      menuButton.addEventListener('click', () => menuButton.setAttribute('aria-expanded', String(menu.classList.toggle('open'))));
      menu.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
      document.addEventListener('click', event => { if (!event.target.closest('.tp-header')) closeMenu(); });
    }
    document.querySelectorAll('[data-announcement]').forEach(banner => {
      if (banner.dataset.bound) return;
      banner.dataset.bound = 'true';
      const toggle = banner.querySelector('[data-announcement-toggle]');
      toggle?.addEventListener('click', () => {
        const paused = banner.classList.toggle('is-paused');
        toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
        toggle.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    const video = document.getElementById('heroVid');
    const play = document.getElementById('tpVideoPlay');
    const sound = document.getElementById('tpVideoSound');
    if (video && play && sound && !video.dataset.bound) {
      video.dataset.bound = 'true';
      const state = () => {
        const label = video.paused ? play.dataset.resume : play.dataset.pause;
        play.querySelector('[data-video-text]').textContent = label;
        play.querySelector('[data-video-text]').hidden = !video.paused;
        play.setAttribute('aria-label', label);
        play.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
        const soundLabel = video.muted ? sound.dataset.unmute : sound.dataset.mute;
        sound.setAttribute('aria-label', soundLabel);
        sound.querySelector('[data-sound-text]').textContent = soundLabel;
      };
      const attemptPlay = () => { video.play().then(state).catch(state); };
      video.muted = true;
      video.volume = 1;
      video.addEventListener('play', state);
      video.addEventListener('pause', state);
      video.addEventListener('volumechange', state);
      video.addEventListener('error', () => { play.querySelector('[data-video-text]').hidden = false; play.querySelector('[data-video-text]').textContent = play.dataset.error; play.setAttribute('aria-label', play.dataset.error); play.disabled = true; sound.disabled = true; });
      play.addEventListener('click', () => { if (video.paused) attemptPlay(); else video.pause(); });
      sound.addEventListener('click', () => { video.muted = !video.muted; if (!video.muted && video.paused) attemptPlay(); state(); });
      state();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.removeAttribute('autoplay'); video.pause(); state(); }
      else attemptPlay();
      document.addEventListener('visibilitychange', () => { if (document.hidden && !video.paused) video.pause(); });
    }
    document.querySelectorAll('[data-wallet-card]').forEach(card => {
      if (card.dataset.bound) return;
      card.dataset.bound = 'true';
      card.querySelectorAll('[data-card-colour]').forEach(button => button.addEventListener('click', () => {
        card.querySelectorAll('[data-card-colour]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        card.querySelectorAll('[data-card-link]').forEach(link => link.href = button.dataset.url);
        const image = card.querySelector('.tp-wallet-image img');
        image.removeAttribute('srcset');
        image.src = button.dataset.image;
        image.alt = `${card.querySelector('h3').textContent.trim()} — ${button.getAttribute('aria-label')}`;
        updatePrice(card.querySelector('[data-card-price]'), button);
      }));
    });
    document.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      const form = root.querySelector('#tpForm');
      const mainImage = root.querySelector('#tpMain');
      const thumbs = Array.from(root.querySelectorAll('#tpThumbs button'));
      const radios = root.querySelectorAll('input[name="tp-colour"]');
      const sticky = root.querySelector('[data-sticky-buy]');
      const buyAnchor = root.querySelector('[data-buy-anchor]');
      const errorBox = root.querySelector('#tpFormError');
      const zoom = root.querySelector('[data-zoom-dialog]');
      const selectImage = button => {
        thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        mainImage.src = button.dataset.src;
        mainImage.alt = button.dataset.alt || root.querySelector('h1').textContent;
        const euroPhoto = button.dataset.euroPhoto === 'true';
        root.querySelectorAll('[data-banknote-caption]').forEach(caption => { caption.hidden = !euroPhoto; });
        if (euroPhoto) mainImage.setAttribute('aria-describedby', 'tpBanknoteCaption');
        else mainImage.removeAttribute('aria-describedby');
        if (zoom) { zoom.querySelector('img').src = button.dataset.src; zoom.querySelector('img').alt = mainImage.alt; }
        if (zoom && euroPhoto) zoom.querySelector('img').setAttribute('aria-describedby', 'tpZoomBanknoteCaption');
        else if (zoom) zoom.querySelector('img').removeAttribute('aria-describedby');
      };
      const updateButtons = () => {
        const selected = form.querySelector('input[name="tp-colour"]:checked');
        const available = selected?.dataset.avail === 'true';
        ['tpAdd', 'tpBuy', 'tpStickyAdd'].forEach(id => {
          const button = root.querySelector(`#${id}`);
          button.disabled = !available || form.dataset.busy === 'true';
          button.textContent = form.dataset.busy === 'true' ? root.dataset.adding : id === 'tpBuy' ? root.dataset.buy : available ? root.dataset.add : root.dataset.sold;
        });
      };
      const selectVariant = radio => {
        root.querySelector('#tpVariant').value = radio.value;
        root.querySelector('#tpColour').textContent = radio.dataset.title;
        updatePrice(root.querySelector('#tpPrice'), radio);
        root.querySelector('[data-sticky-colour]').textContent = radio.dataset.title;
        root.querySelector('[data-sticky-price]').textContent = root.querySelector('#tpPrice [data-launch-sale]').dataset.launchSale === 'true' ? radio.dataset.salePrice : radio.dataset.price;
        const stock = root.querySelector('#tpStock');
        const available = radio.dataset.avail === 'true';
        stock.textContent = available ? root.dataset.stock : root.dataset.out;
        stock.toggleAttribute('data-out', !available);
        const matching = thumbs.filter(button => button.dataset.alt.toLowerCase().includes(radio.dataset.title.toLowerCase()));
        thumbs.forEach(button => { button.hidden = matching.length > 0 && !matching.includes(button); });
        const selectedImage = (matching.length ? matching : thumbs).find(button => button.dataset.src === radio.dataset.img) || matching[0] || thumbs[0];
        if (selectedImage) selectImage(selectedImage);
        else if (radio.dataset.img) mainImage.src = radio.dataset.img;
        updateButtons();
      };
      radios.forEach(radio => radio.addEventListener('change', () => {
        selectVariant(radio);
        const url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState(null, '', url);
        errorBox.hidden = true;
      }));
      thumbs.forEach(button => button.addEventListener('click', () => selectImage(button)));
      const current = form.querySelector('input[name="tp-colour"]:checked');
      if (current) selectVariant(current);
      root.querySelector('[data-zoom-open]')?.addEventListener('click', () => zoom.showModal());
      root.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoom.close());
      zoom?.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
      let pendingScroll = false;
      const updateSticky = () => { sticky.hidden = !(matchMedia('(max-width: 760px)').matches && buyAnchor.getBoundingClientRect().bottom < 0); pendingScroll = false; };
      window.addEventListener('scroll', () => { if (!pendingScroll) { pendingScroll = true; requestAnimationFrame(updateSticky); } }, {passive: true});
      window.addEventListener('resize', updateSticky);
      updateSticky();
      form.addEventListener('submit', async event => {
        if (form.dataset.busy === 'true') { event.preventDefault(); return; }
        if (event.submitter?.id === 'tpBuy') return;
        event.preventDefault();
        if (bagController && !bagController.reserve()) return;
        form.dataset.busy = 'true';
        errorBox.hidden = true;
        const body = new FormData(form);
        if (bagController) {
          body.set('sections', bagController.sectionId);
          body.set('sections_url', location.pathname + location.search);
        }
        updateButtons();
        try {
          const response = await fetch(root.dataset.addUrl, {method: 'POST', body, headers: {'Accept':'application/json'}});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.error);
          if (bagController) {
            await bagController.confirm(data.sections, event.submitter);
            return;
          }
          const cartUrl = new URL(root.dataset.cartUrl, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) cartUrl.searchParams.set('preview_theme_id', preview);
          location.assign(cartUrl.href);
        } catch (error) {
          errorBox.textContent = error.message === 'Failed to fetch' ? root.dataset.error : error.message || root.dataset.error;
          errorBox.hidden = false;
          errorBox.scrollIntoView({block:'center',behavior:'smooth'});
        } finally { form.dataset.busy = 'false'; updateButtons(); bagController?.release(); }
      });
    });
    const revealHash = () => {
      if (!location.hash) return;
      const target = document.getElementById(location.hash.slice(1));
      if (target?.tagName === 'DETAILS') target.open = true;
    };
    document.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
      const target = document.getElementById(link.hash.slice(1));
      if (target?.tagName === 'DETAILS') target.open = true;
    }));
    window.addEventListener('hashchange', revealHash);
    revealHash();
    document.querySelectorAll('.rv').forEach(element => element.classList.add('in'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
